import polylabel from 'polylabel';

import { IMultiPolygon, IPolygon } from '@/models';

/**
 * Calculates the center coordinates of a polygon or multipolygon.
 * For MultiPolygon, finds the largest polygon by bounding box area and returns its center.
 */
export function calculatePolygonCenter(
  polygon: IPolygon | IMultiPolygon,
): number[] {
  if (polygon.type === 'Polygon') {
    return polylabel(polygon.coordinates);
  } else {
    // For MultiPolygon, find the largest polygon and get its center
    const polygons = polygon.coordinates;
    let largestPolygonIndex = 0;
    let largestArea = 0;

    for (let i = 0; i < polygons.length; i++) {
      const poly = polygons[i];
      if (poly.length === 0) continue;

      const ring = poly[0];
      let minLng = ring[0][0];
      let maxLng = ring[0][0];
      let minLat = ring[0][1];
      let maxLat = ring[0][1];

      for (const coord of ring) {
        if (coord[0] < minLng) minLng = coord[0];
        if (coord[0] > maxLng) maxLng = coord[0];
        if (coord[1] < minLat) minLat = coord[1];
        if (coord[1] > maxLat) maxLat = coord[1];
      }

      const area = (maxLng - minLng) * (maxLat - minLat);
      if (area > largestArea) {
        largestArea = area;
        largestPolygonIndex = i;
      }
    }

    return polylabel(polygons[largestPolygonIndex]);
  }
}
